jQuery(document).ready(() => {

	// Open and Close Accordion
	///////////////////////////////////////////////////////////////////////////////////
	const items = jQuery(`[data-subnav-accordion='item']`);
	
	items.each(function () {

		jQuery(this).click((e) => {
			const width = getWidthWindow();
			if (width < 768) {
				e.preventDefault();
				const icon = jQuery(this).children('.mobile');
				jQuery(this).siblings('ul').slideToggle();
				if (icon.hasClass('icon-icon-chevron-down')) {
					icon.addClass('icon-icon-chevron-up');
					icon.removeClass('icon-icon-chevron-down');
				} else {
					icon.removeClass('icon-icon-chevron-up');
					icon.addClass('icon-icon-chevron-down');
				}
			}
		});

	});

	// Open Accordion in Desktop
	///////////////////////////////////////////////////////////////////////////////////

	const validateOpenAccordion = () => {
		const width = getWidthWindow();
		const icon = items.children('.mobile');
		if (width >= 768) {
			items.siblings('ul').css({ display: 'block' });
		} else {
			items.siblings('ul').css({ display: 'none' });
			icon.removeClass('icon-icon-chevron-up');
			icon.addClass('icon-icon-chevron-down');
		}
	}

	validateOpenAccordion();
	jQuery(window).resize(() => {
		validateOpenAccordion();	
	});

	// Function por get Width on resize
	///////////////////////////////////////////////////////////////////////////////////
	function getWidthWindow () {
		let width = jQuery(window).width();
		jQuery(window).resize(() => {
			width = jQuery(window).width();
			return width;
		});

		return width;
	}

});